export const getFilters = (userId, state) =>
  state[userId]?.filters || state.filters;
export const getDateOption = (userId, state) =>
  state[userId]?.dateOption || state.dateOption;
export const getSignalRDataEnrichmentId = state =>
  state.signalRDataEnrichmentId;
